import Config from 'netxcore@netx/core-app/config';

Object.assign(Config, {
	CSS_CUSTOM_PROPERTY_PREFIX: '--mdc-theme-',
	CSS_CUSTOM_PROPERTIES: {
		'light-primary': '#1C2638',
		'light-on-primary': '#ffffff',

		'light-secondary': '#1C2638',
		'light-on-secondary': '#ffffff',

		'dark-primary': '#cccccc',
		'dark-on-primary': '#1C2638',

		'dark-secondary': '#cccccc',
		'dark-on-secondary': '#1C2638',
	},
	PASSIVE_ALERT_DELAY: 3000,
});

export default Config;
